/* Cart Drawer Cross-sell — FBT Sprint 29 Apr 2026 */
/* v4.1: Cross-sell renders BELOW checkout button — never blocks proceed — fix 02 May 2026 */

(function() {
  'use strict';

  const CROSSSELL_RULES = [
    { buyHandles: ['portable-blender-smoothie-milk-shakes-crushing-ice-juices', 'portable-blender-smoothie-milk-shakes-crushing-ice-juices-1', 'portable-blender-bottle-usb-rechargeable-450ml-230watts', 'portable-blender-bottle-long-lasting-6000-mah-battery', 'ultra-slim-portable-blender-bottle-180w-power-3000mah'], getHandle: 'instacuppa-cleaning-brush-for-travel-mug-infuser', label: '50% OFF at checkout' },
    { buyHandles: ['instacuppa-cold-brew-coffee-with-tritan-glass-infuser-pitcher', 'instacuppa-borosilicate-glass-cold-brew-coffee-maker-iced-tea-pot', 'instacuppa-cold-brew-coffee-maker-2-2l-bpa-free-jug', 'instacuppa-french-press-coffee-maker-600-ml-aero-adition', 'french-press-coffee-maker-4-part-superior-filtration', 'french-press-travel-coffee-mug-black-with-vacuum-insulation', 'french-press-tea-infuser-2-in-1-glass-coffee-maker-1000ml', 'french-press-coffee-maker-1000-ml-304-grade-stainless'], getHandle: 'coffee-frother-battery-operated-with-stand', label: '50% OFF at checkout' },
    { buyHandles: ['3-in-1-espresso-coffee-maker-ground-coffee-pods-capsules'], getHandle: 'coffee-frother-machine-4-in-1-hot-cold-foam-maker', label: '50% OFF at checkout' },
    { buyHandles: ['ultrasonic-cool-mist-humidifier-room-cold-cough-relief'], getHandle: 'instacuppa-rechargeable-aroma-oil-diffuser', label: '30% OFF at checkout' },
    { buyHandles: ['instacuppa-rechargeable-aroma-oil-diffuser'], getHandle: 'ultrasonic-cool-mist-humidifier-room-cold-cough-relief', label: '30% OFF at checkout' },
    { buyHandles: ['rechargeable-electric-chopper-stainless-steel-blades-3'], getHandle: 'rechargeable-mini-electric-chopper-stainless-steel-blades', label: '50% OFF at checkout' },
    { buyHandles: ['multipurpose-electric-kettle-cum-cooker-free-steamer-momos', 'copy-of-instacuppa-multipurpose-electric-kettle-cum-cooker-with-free-steamer-for-momos-vegetables-boiler-trays-for-idly-eggs-1-2-liter-600-watts'], getHandle: '3-1-multi-cook-kettle-steamer-1-l-non-stick-inner-pot', label: '50% OFF at checkout' },
    { buyHandles: ['portable-electric-kettle-temperature-control-travel-water'], getHandle: 'instacuppa-portable-multicook-kettle-steel-version-1000ml', label: '50% OFF at checkout' },
    { buyHandles: ['automatic-curd-maker-machine-1l'], getHandle: 'greek-yogurt-maker-1100-ml-for-thick-homemade-hung-curd', label: '50% OFF at checkout' },
    { buyHandles: ['automatic-stirring-electric-popcorn-maker-butter-melting', 'electric-hot-air-popcorn-maker-machine'], getHandle: 'instacuppa-silicone-dish-drying-mat-quick-drying-foldable', label: '50% OFF at checkout' },
    { buyHandles: ['instacuppa-bamboo-green-tea-infuser', 'instacuppa-bpa-free-borosilicate-glass-water-bottle-with-wide-mouth-flip-top-sipper', 'instacuppa-borosilicate-glass-infuser-water-bottle-flip-top-sipper-lid', 'borosilicate-glass-infuser-water-bottle-full-length-steel', 'borosilicate-glass-water-bottle-wide-mouth-sports-sipper', 'instacuppa-bpa-free-borosilicate-glass-water-bottle-1000-ml-with-wide-mouth-straw-sipper-lid', 'glass-tea-infuser-bottle-450-ml-double-wall-borosilicate', 'thermos-bottle-1000-ml-double-wall-thermos-flask-vacuum', 'instacuppa-sports-thermos-water-bottle-with-straw-sipper-lid', 'instacuppa-vacuum-insulated-thermos-water-bottle-with-wide-mouth-screw-lid', 'instacuppa-thermos-green-tea-infuser-water-bottle-550-ml-with-removable-stainless-steel-filter', 'instacuppa-thermos-water-bottle-2000-ml-double-wall-thermos-flask-black', 'instacuppa-thermos-flask-350-ml-double-wall-thermos-bottle-vacuum-insulated-stainless-steel-retains-hot-and-cold-temperatures-black', 'instacuppa-thermos-fruit-infuser-water-bottle-1-litre-with-full-length-stainless-steel-infuser', 'instacuppa-thermos-steel-fruit-infuser-water-bottle-1-litre', 'fruit-infuser-water-bottle-1-litre-full-length-tritan', 'fruit-infuser-water-bottle-1-litre-polar-infusion-edition', 'instacuppa-thermos-bottle-with-flip-top-carry-lid-1000-ml-double-wall-thermos-flask-vacuum-insulated-stainless-steel-retains-hot-and-cold-temperatures', 'motivational-water-bottle-1000-ml-motivational-quote-time', 'thermos-flask-stainless-steel-mug-twist-pour-stopper-screw'], getHandle: 'instacuppa-cleaning-brush-for-travel-mug-infuser', label: '50% OFF at checkout' }
  ];

  const productCache = {};

  const CartCrosssell = {
    cartHandles: [],
    rendering: false,

    findInsertionPoint() {
      /* Insert AFTER the checkout button so cross-sell never blocks proceed */
      const ctas = document.querySelector('.drawer__footer .cart__ctas');
      if (ctas && ctas.nextSibling) return { parent: ctas.parentNode, before: ctas.nextSibling };
      if (ctas) return { parent: ctas.parentNode, before: null }; /* append at end */
      /* Fallback for full cart page: insert after .cart__ctas */
      const pageCtas = document.querySelector('.cart__ctas');
      if (pageCtas && pageCtas.nextSibling) return { parent: pageCtas.parentNode, before: pageCtas.nextSibling };
      if (pageCtas) return { parent: pageCtas.parentNode, before: null };
      return null;
    },

    ensureContainer() {
      let container = document.getElementById('cart-crosssell-container');
      if (container) return container;

      const point = this.findInsertionPoint();
      if (!point) return null;

      container = document.createElement('div');
      container.id = 'cart-crosssell-container';
      container.style.display = 'none';
      if (point.before) {
        point.parent.insertBefore(container, point.before);
      } else {
        point.parent.appendChild(container);
      }
      return container;
    },

    async refresh() {
      if (this.rendering) return;
      this.rendering = true;
      try {
        await this.loadCart();
        await this.render();
      } catch (err) {
        console.error('Cart crosssell: refresh error', err);
      } finally {
        this.rendering = false;
      }
    },

    async loadCart() {
      try {
        const r = await fetch('/cart.js');
        const cart = await r.json();
        this.cartHandles = cart.items.map(item => item.handle);
      } catch (err) {
        this.cartHandles = [];
      }
    },

    getRecommendations() {
      const recs = [];
      const seen = new Set();
      for (const rule of CROSSSELL_RULES) {
        if (rule.buyHandles.some(h => this.cartHandles.includes(h)) &&
            !this.cartHandles.includes(rule.getHandle) &&
            !seen.has(rule.getHandle)) {
          seen.add(rule.getHandle);
          recs.push({ handle: rule.getHandle, label: rule.label });
        }
      }
      return recs.slice(0, 3);
    },

    async fetchProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      try {
        const r = await fetch('/products/' + handle + '.js');
        if (r.ok) { const d = await r.json(); productCache[handle] = d; return d; }
      } catch (e) {}
      return null;
    },

    async render() {
      const container = this.ensureContainer();
      if (!container) return;

      const recs = this.getRecommendations();
      if (recs.length === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }

      const products = (await Promise.all(
        recs.map(r => this.fetchProduct(r.handle).then(p => p ? Object.assign({}, p, { label: r.label }) : null))
      )).filter(Boolean);

      if (products.length === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }

      var html = '<div class="cart-crosssell"><p class="cart-crosssell__title">Complete Your Setup</p>';
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        var variant = product.variants[0];
        var price = (variant.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
        var cmp = variant.compare_at_price ? (variant.compare_at_price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : null;
        var img = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_180x180$1$2') : '';
        html += '<div class="cart-crosssell__item" data-variant-id="' + variant.id + '">' +
          '<img src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="cart-crosssell__image" width="60" height="60" loading="lazy">' +
          '<div class="cart-crosssell__info"><p class="cart-crosssell__name">' + product.title + '</p>' +
          '<p class="cart-crosssell__price"><span class="cart-crosssell__price-current">Rs. ' + price + '</span>' +
          (cmp ? '<span class="cart-crosssell__price-compare">Rs. ' + cmp + '</span>' : '') +
          '<span class="cart-crosssell__price-badge">' + product.label + '</span></p></div>' +
          '<button type="button" class="cart-crosssell__add-btn" data-variant-id="' + variant.id + '">Add</button></div>';
      }
      html += '</div>';

      /* Re-find container (DOM may have changed during async) */
      var fresh = this.ensureContainer();
      if (!fresh) return;
      fresh.innerHTML = html;
      fresh.style.display = '';

      fresh.querySelectorAll('.cart-crosssell__add-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          CartCrosssell.addToCart(e, btn);
        });
      });
    },

    async addToCart(e, btn) {
      e.preventDefault();
      var vid = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
        });
        if (r.ok) {
          btn.textContent = 'Added!';
          btn.style.background = '#f5a725';
          btn.style.color = '#fff';

          /* Refresh cart drawer WITHOUT closing it or reloading the page */
          try {
            var sectionsUrl = window.location.pathname;
            var fetchUrl = sectionsUrl + '?sections=cart-drawer,cart-icon-bubble';
            var sectionResp = await fetch(fetchUrl);
            var sectionData = await sectionResp.json();

            /* Update cart drawer HTML */
            if (sectionData['cart-drawer']) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(sectionData['cart-drawer'], 'text/html');
              var newDrawerInner = doc.querySelector('#CartDrawer');
              var currentDrawer = document.getElementById('CartDrawer');
              if (newDrawerInner && currentDrawer) {
                currentDrawer.innerHTML = newDrawerInner.innerHTML;
              }
            }

            /* Update cart icon bubble count */
            if (sectionData['cart-icon-bubble']) {
              var parser2 = new DOMParser();
              var doc2 = parser2.parseFromString(sectionData['cart-icon-bubble'], 'text/html');
              var newBubble = doc2.querySelector('#cart-icon-bubble');
              var currentBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            }

            /* Re-inject cross-sell after drawer HTML update */
            setTimeout(function() { CartCrosssell.refresh(); }, 300);
          } catch(refreshErr) {
            /* Fallback: reload if section fetch fails */
            setTimeout(function() { window.location.reload(); }, 800);
          }
        } else {
          btn.textContent = 'Error';
          btn.disabled = false;
          setTimeout(function() { btn.textContent = 'Add'; }, 2000);
        }
      } catch (err) {
        btn.textContent = 'Error';
        btn.disabled = false;
        setTimeout(function() { btn.textContent = 'Add'; }, 2000);
      }
    }
  };

  /* Strategy: Monkey-patch CartDrawer.renderContents to inject cross-sell AFTER
     the drawer HTML is replaced. This is the most reliable approach because
     pub/sub fires BEFORE renderContents, not after. */
  function patchCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var originalRenderContents = cartDrawer.renderContents;
    if (!originalRenderContents) return;

    cartDrawer.renderContents = function(parsedState) {
      /* Call the original — this replaces #CartDrawer innerHTML and calls open() */
      originalRenderContents.call(this, parsedState);

      /* Now inject cross-sell AFTER the HTML replacement */
      /* Use setTimeout to run after the open() setTimeout inside renderContents */
      setTimeout(function() {
        CartCrosssell.refresh();
      }, 300);
    };
  }

  /* Also watch for drawer open via cart icon click (no renderContents in that case) */
  function observeDrawerOpen() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var wasActive = false;
    var observer = new MutationObserver(function() {
      var isActive = cartDrawer.classList.contains('active');
      if (isActive && !wasActive) {
        /* Drawer just opened — refresh cross-sell */
        setTimeout(function() { CartCrosssell.refresh(); }, 200);
      }
      wasActive = isActive;
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    patchCartDrawer();
    observeDrawerOpen();
    /* Initial refresh for page load with items in cart */
    CartCrosssell.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();